<div class="row">
  <div class="col-12 autocomplete-wrapper">
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options">
      </formly-form>
    </form>
  </div>
</div>
